import { buildScopedI18n } from '../../../utils/buildScopedI18n';
import dspEsCL from './locales/es-CL.json';
import dspEnUS from './locales/en-US.json';
import dspPtBR from './locales/pt-BR.json';

export const dailyStatePanelUnholsterI18n = buildScopedI18n({
  esCL: dspEsCL,
  enUS: dspEnUS,
  ptBR: dspPtBR,
});
